// ad-banner — article_banner 广告位横幅。
// top    → 渲染 visible[0..4](位置号 1-5)
// bottom → 渲染 visible[5..9](位置号 6-10)
// 空位补 <AdPlaceholder variant="banner">。横幅 350×60 宽度自适应,撑满内容宽(跟左右对齐)。
import { useState, useEffect } from 'react'
import { AD_CAP } from '../../_lib/ad-slot'
import type { Ad } from '../../_lib/ad-rotate'
import { computeVisible } from '../../_lib/ad-rotate'
import { useAdFeed } from '../../_lib/ad-api'
import { getForumIdentity } from '../../_lib/forum-device-id'
import { trackAndOpen } from './track-click'
import { AdPlaceholder } from './ad-placeholder'

const SLOT = 'article_banner'
const CAP = AD_CAP[SLOT] // 10

type BannerLocation = 'top' | 'bottom'

export function AdBanner({ location }: { location: BannerLocation }) {
  const { data } = useAdFeed(SLOT)
  const [visible, setVisible] = useState<Ad[]>([])

  useEffect(() => {
    if (!data) return
    const identity = getForumIdentity()
    computeVisible(data.ads, data.order_mode, identity, CAP)
      .then(setVisible)
      .catch(() => setVisible([]))
  }, [data])

  // top  → indices 0..4 (positions 1-5)
  // bottom → indices 5..9 (positions 6-10)
  const startIdx = location === 'top' ? 0 : 5
  const endIdx = location === 'top' ? 5 : 10

  return (
    <div className="flex flex-col gap-2">
      {Array.from({ length: endIdx - startIdx }, (_, i) => {
        const idx = startIdx + i
        const pos = idx + 1
        const ad = visible[idx]
        if (ad) {
          return (
            <button
              key={ad.id}
              type="button"
              data-testid={`ad-banner-${pos}`}
              className="w-full"
              onClick={() => trackAndOpen(ad.id, SLOT, pos, ad.target_url)}
            >
              <img src={ad.image_url} alt="广告" className="h-[60px] w-full rounded bg-white object-contain" />
            </button>
          )
        }
        return (
          <div key={`placeholder-banner-${pos}`} data-testid={`ad-banner-${pos}`}>
            <AdPlaceholder variant="banner" />
          </div>
        )
      })}
    </div>
  )
}
